<template>
  <v-dialog
    fullscreen
    v-model="dialog"
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="text-center mt-12">
            <div class="text-h5 mb-4">Impostazione {{ therm.nome }}</div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field label="Nome" v-model="nome" outlined></v-text-field>
          </v-col>
        </v-row>
        <v-divider />
        <v-row no-gutters class="mt-6" justify="center">
          <v-col cols="12" v-if="!therm.isExternal">
            <v-slider
              v-model="gal_h"
              :max="5"
              :min="0"
              step="0.1"
              label="gal/h"
              thumb-label="always"
              class="mt-4"
              color="teal"
              :track-color="'teal lighten-3'"
              outlined
              hide-details
            ></v-slider>
          </v-col>

          <v-col
            cols="12"
            v-if="!therm.isExternal"
            class="text-center grey--text text--lighten-1"
            >Litri/ora: {{ (gal_h * 3.78541).toFixed(1) }} L/h</v-col
          >
        </v-row>
        <v-divider v-if="!therm.isExternal" class="my-4" />
        <v-row no-gutters>
          <v-col
            cols="12"
            v-if="!therm.isExternal"
            class="text-center grey--text text--lighten-1 my-4"
            ><v-icon class="mr-4" @click="position--">mdi-minus</v-icon>
            Posizione: {{ position + 1 }}
            <v-icon class="ml-4" @click="position++">mdi-plus</v-icon>
          </v-col>
        </v-row>
        <v-divider v-if="!therm.isExternal" class="my-4"></v-divider>
        <v-row no-gutters>
          <v-col
            cols="12"
            v-if="!therm.isExternal"
            class="text-center grey--text text--lighten-1 mt-4"
          >
            <v-switch
              v-model="phoneEnabled"
              inset
              label="Allarme Telefonico"
            ></v-switch>
          </v-col>
          <v-col
            cols="12"
            v-if="!therm.isExternal"
            class="text-center grey--text text--lighten-1"
          >
            <v-switch
              v-model="pushEnabled"
              inset
              label="Notifiche Push"
            ></v-switch>
          </v-col>
        </v-row>
        <v-divider class="my-4" v-if="!therm.isExternal"></v-divider>
        <v-card outlined>
          <v-card-title class="grey--text font-weight-light">
            Danger Zone
          </v-card-title>
          <v-card-text>
            <v-row no-gutters class="mt-n4">
              <v-col class="">
                <v-dialog v-model="dialogDeleteRecords" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      outlined
                      block
                      class="mt-4"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      Elimina Records Termostato
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="red--text text-subtitle-1">
                      Conferma Eliminazione
                    </v-card-title>
                    <v-card-text>
                      Sei sicuro di voler eliminare i records del termostato
                      <strong>{{ therm.nome }}</strong
                      >? Questa azione non è reversibile!

                      <v-select
                        class="mt-4"
                        v-model="deleteOption"
                        :items="[
                          {
                            text: 'Solo i records più vecchi di 3 giorni',
                            value: 3,
                          },
                          {
                            text: 'Solo i records più vecchi di 7 giorni',
                            value: 7,
                          },
                          {
                            text: 'Solo i records più vecchi di 30 giorni',
                            value: 30,
                          },
                          {
                            text: 'Solo i records più vecchi di 180 giorni',
                            value: 180,
                          },
                          {
                            text: 'Solo i records più vecchi di 1 anno',
                            value: 365,
                          },
                          { text: 'Solo i records più vecchi di 1 anno', value: 0 },
                        ]"
                        label="Scegli un'opzione"
                        item-text="text"
                        item-value="value"
                        outlined
                      ></v-select>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        text
                        color="grey"
                        @click="dialogDeleteRecords = false"
                        >Annulla</v-btn
                      >
                      <v-btn color="red" outlined @click="eliminaRecords"
                        >Elimina</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col class="">
                <v-dialog v-model="dialogDeleteTherm" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      outlined
                      block
                      class="mt-4"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      Elimina Termostato
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="red--text text-subtitle-1">
                      Conferma Eliminazione
                    </v-card-title>
                    <v-card-text>
                      Sei sicuro di voler eliminare il termostato
                      <strong>{{ therm.nome }}</strong
                      >? Questa azione non è reversibile e verranno eliminati
                      tutti i records ad esso collegati!
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        text
                        color="grey"
                        @click="dialogDeleteTherm = false"
                        >Annulla</v-btn
                      >
                      <v-btn color="red" outlined @click="eliminaThermostat"
                        >Elimina</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="mb-8">
        <v-spacer></v-spacer>
        <v-btn outlined color="green" @click="save()">Salva</v-btn>
        <v-btn text @click="dialog = false">Annulla</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import therm_edit_mixin from "../mixin/therm_edit_mixin";
export default {
  name: "editBox",
  mixins: [therm_edit_mixin],
  props: {
    therm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>